<div *ngIf="exibirLoaderFullscreen">
  <app-loader></app-loader>
</div>

<div class="chat_icone">
  <dynamic-form [fields]="regConfigChatIcon"></dynamic-form>
</div>

<div class="modal__cadastro__chat" *ngIf="exibePopupChatLover">
  <div>
    <img
      src="assets/images/icons/x_circle.png"
      class="modal__cadastro__chat__close"
      (click)="exibePopupChatLover = false"
    />
    <div>
      <div
        #chatScroll
        class="divMensagens"
        [ngClass]="{ divMensagensTermos: indexChat == 6 }"
      >
        <img
          src="assets/images/others/atendente_chat.png"
          class="chat_atendente"
        />
        <div
          class="divMensagem"
          *ngFor="let m of chatMensagens"
          [ngClass]="{ divMensagemUsuario: m.remetente == 1 }"
        >
          <div class="divMensagemTriangulo" *ngIf="m.remetente == 2"></div>
          <p>{{ m.mensagem }}</p>
        </div>
      </div>
      <div class="divChatBottom">
        <dynamic-form [fields]="regConfigCadastroCacauLover"></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverTermos"
          *ngIf="indexChat == 6"
        ></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverFinalizar"
          *ngIf="indexChat >= 6"
        ></dynamic-form>
        <dynamic-form
          [fields]="regConfigCadastroCacauLoverFooter"
        ></dynamic-form>
      </div>
    </div>
  </div>
</div>
